import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/testimonials`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les témoignages
export const getAllTestimonials = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allTestimonials`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors du chargement des témoignages:", error);
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// POST
// Fonction pour ajouter un témoignage
export const addTestimonial = async (newTestimonial) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addTestimonial`,
      newTestimonial,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 201)
      throw new Error("Failed to add new testimonial");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de l'ajout d'un témoignage:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Upload image pour la catégorie 'testimonials /:id/photo'
export const uploadImage = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        "x-category": "testimonials", // Ajout du header pour spécifier 'testimonials'
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image:", error);
    return null;
  }
};

/// PUT
// Fonction pour modifier un témoignage avec son id
export const updateTestimonial = async (testimonial) => {
  if (!testimonial.id) {
    throw new Error("L'ID du témoignage est manquant.");
  }
  try {
    const response = await axios.put(
      `${apiUrl}/updateTestimonial/${testimonial.id}`,
      testimonial,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200)
      throw new Error("Failed to update testimonial");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification d'un témoignage:", error);
    return null;
  }
};

/// DELETE
// Fonction pour supprimer un témoignage avec son id
export const deleteTestimonial = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteTestimonial/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200)
      throw new Error("Failed to delete testimonial");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error("Erreur lors de la suppression d'un témoignage:", error);
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};
